/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';
import { CheckIcon } from '@coursera/cds-icons';

type Props = {
  objective: string;
  checkSize?: 'small' | 'large';
};

const styles = {
  objective: css`
    display: flex;
    flex-direction: row;
    gap: 16px;
  `,
  icon: css`
    flex-shrink: 0;
    margin-top: 4px;
  `,
};

// This component renders one single learning objective
const LearningObjective = ({ objective, checkSize = 'small' }: Props) => {
  return (
    <div css={styles.objective}>
      <CheckIcon size={checkSize} css={styles.icon} />
      <Typography2 variant="bodyPrimary" component="p">
        {objective}
      </Typography2>
    </div>
  );
};

export default LearningObjective;
